import EventBus from '../services/service.eventBus';

import { actions as offerActions } from './actions.offer';
import { actions as optimizelyActions } from './actions.optimizely';
import { actions as pageParamsActions } from './actions.page-params';

export const onCertificateInit = async (
  offerID,
  entry?: string,
  offerCode?: string,
  lnxCode?: string,
  utmSource?: string,
  isAdmin?: boolean,
  category?: string,
  canEditMileageIneligible?: boolean,
  minimumMileageIneligibleThreshold?: number,
  prospectId?,
  dealerName?: string,
  showKelleyBuysYourCar?: boolean
) => {
  pageParamsActions.onReceivedParams({ entry, offerCode, lnxCode, utmSource, isAdmin, category, dealerName });

  if (offerID) {
    optimizelyActions.onOptimizelyCertificateOptimizedLeadRoutingCheck();
    await optimizelyActions.onOptimizelyConsumerMarketConfidenceCheck();
    await optimizelyActions.onOptimizelyAppleWalletPassCheck();

    EventBus.publish('CertificateInit', offerID);
    await offerActions.onOfferFetch(offerID, true, showKelleyBuysYourCar);
  } else if (prospectId) {
    EventBus.publish('InProgressOfferInit', prospectId);
    await offerActions.onInProgressOfferFetch(prospectId);
  }

  if (canEditMileageIneligible) {
    offerActions.onUpdateOfferIneligible(canEditMileageIneligible, minimumMileageIneligibleThreshold);
  }
  optimizelyActions.onOptimizelyCertificateUIEnhancementCheck();
  await optimizelyActions.onOptimizelyAcceptOrCounterofferCheck();
};
